module.exports = __webpack_public_path__ + "media/packs/src/webfonts/fa-solid-900-a84653d4fe0072d182b63c5cb70d821a.svg";